'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const ModalDialogBase_ModalDialogContext = require('./ModalDialogContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);

const modalOverlay = "_modal-overlay_i1kvn_17";
const fadeIn = "_fade-in_i1kvn_1";
const fadeOut = "_fade-out_i1kvn_1";
const modal = "_modal_i1kvn_17";
const styles = {
	modalOverlay: modalOverlay,
	fadeIn: fadeIn,
	fadeOut: fadeOut,
	modal: modal
};

const OverlayBase = (_a) => {
  var { children, className, isDismissable = true, isOpen, onOpenChange } = _a, props = tslib_es6.__rest(_a, ["children", "className", "isDismissable", "isOpen", "onOpenChange"]);
  const contextValue = React.useMemo(() => ({ isDismissable }), [isDismissable]);
  return jsxRuntime.jsx(ModalDialogBase_ModalDialogContext.ModalDialogContext.Provider, { value: contextValue, children: jsxRuntime.jsx(reactAriaComponents.ModalOverlay, Object.assign({ className: styles.modalOverlay, "data-zds": true, isDismissable, isOpen, isKeyboardDismissDisabled: !isDismissable, onOpenChange }, props, { children: jsxRuntime.jsx(reactAriaComponents.Modal, { className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx__default.default(styles.modal, dynamicClassName);
  }, "data-zds": true, children }) })) });
};

exports.OverlayBase = OverlayBase;
//# sourceMappingURL=OverlayBase.cjs.js.map
